export const environment = {
  production: true,
  // for staging
  // serverUrl: 'https://en.farazpardazan.com/en/',
  //
  serverUrl: '/en/',
  siteKey: '6LecA_4UAAAAAI_cT_jrWsN9mvHHWX4mqQ-Ldrai',
  version: '2.8.3',
  platform: 'PWA',
};
